import { PRODUCT_AREA } from '@leagueplatform/analytics';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useLocation } from 'react-router-dom';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useCommonPageSetup } from '@scfhp-web/shared-module';

const useQueryParams = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};

export const AuthorizationDetailPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: 'STR_AUTHORIZATIONS' });
  useCommonPageSetup({ title, productArea: PRODUCT_AREA.GET_CARE });

  const params = useQueryParams();
  const authId = params.get('authId') || '';

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <StackLayout
        orientation="vertical"
        css={{
          maxWidth: '894px',
          gap: '12px',
        }}
      >
        <Masonry
          rootNodeId="authorizationDetails$root"
          initialQueryParams={{ authId }}
        />
      </StackLayout>
    </MainPageContainer>
  );
};
